import axios from 'axios';

import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { grey } from '@mui/material/colors';

import HeadLine2 from '../common/HeadLine2.js'
import StandardButton from '../common/StandardButton.js'
import copyTableToClipboard from '../utility/copyTableToClipboard.js'

export default function YearSales(props) {
  const { token, salesMonth } = props;

  const [amount, setAmount] = useState([]);
  const [total, setTotal] = useState([]);

  const [alertStatus, setAlertStatus] = useState({
    open: false,
    type: "success",
    message: ""
  });


  useEffect(() => {
    setAlertStatus({
      open: false,
      type: "close",
      message: ""
    });

    const apiURL = process.env.REACT_APP_BASEURL;
    const getURL = `${apiURL}/data_send/agency_sales_all_years`;

    const rows = new Array(0);

    // setBackdropOpen(true);

    axios({
      method: "GET",
      url:getURL,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(
        response => {

          console.log(response.data.total);
          // console.log(response.data.rows);
          setAmount(response.data.rows)
          setTotal(response.data.total)

        }).catch((error) => {
          // setBackdropOpen(false)
          console.log('axios error')

          if (error.response) {
            setAlertStatus({
              open: true,
              type: "error",
              message: `接続エラー(${error.response.status})`
            });
          } else {
            setAlertStatus({
              open: true,
              type: "error",
              message: `エラー(${error})`
            });
          }
        }
        );
  }, [])


  return(
    <Box sx={{ p: 4 }}>
      <HeadLine2>
        ■ 年間売上
      </HeadLine2>

      <StandardButton variant="contained" color="primary" onClick={() => copyTableToClipboard('year-table')}>
        クリップボードにコピー
      </StandardButton>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table id='year-table'>
          <TableHead>
            <TableRow>
              {/* <TableCell>ID</TableCell> */}
              <TableCell sx={{ width: 120, maxWidth: 120 }}>名前</TableCell>
              <TableCell sx={{ width: 160, maxWidth: 160 }}>薬名</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>2021</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>2022</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>2023</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>2024</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>2025</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>2026</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {amount.map((row) => (
              <>
                <TableRow key={row.id}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.product_name}</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['2021']}</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['2022']}</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['2023']}</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['2024']}</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['2025']}</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['2026']}</TableCell>
                </TableRow>
              </>
            ))}
            {total.map((row) => (
              <>
              <TableRow key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.product_name}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['2021']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['2022']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['2023']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['2024']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['2025']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['2026']}</TableCell>
              </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}